// components/ExeCore.js
import React from 'react';

export default function ExeCore({ image, size = 200, children }) {
    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2
        }}>
            {image && (
                <img
                    src={image}
                    alt="Mars"
                    style={{
                        width: size,
                        display: 'block',
                        margin: '0 auto'
                    }}
                />
            )}
            {children}
        </div>
    );
}
